export default __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/shield_null-7f819bc55c6fb5156f97a16243b4b230.png";